import {useEffect, useState} from 'react'

export const useScrolled = () => {
    const [isScrolled, setScrolled] = useState()

    useEffect(() => {
        // @ts-ignore
        const onScoll = (event: Event) => setScrolled(event.currentTarget.scrollY > 1)

        window.addEventListener('scroll', onScoll)
        return () => window.removeEventListener('scroll', onScoll)
    }, [])

    return isScrolled
}
